import { setCookie } from "nookies";
import { NextPageContext } from "next";

export const TOKEN_STORAGE_KEY = "teslainvest.authToken";

const storeAuthorization = (
  token: string,
  refreshToken?: string,
  ctx?: NextPageContext
) => {
  setCookie(ctx, TOKEN_STORAGE_KEY, token, {
    path: "/"
  });
};

export default storeAuthorization;
